import axios from 'axios'
import { getSavedState, saveState } from '../store-utils'

export const state = {
  cachedStatuses: getSavedState('device.statuses'),
  selectedStatus: null,
}

export const getters = {
  cachedStatuses(state) {
    return state.cachedStatuses
  },
  selectedStatus(state) {
    return state.selectedStatus
  },
}

export const mutations = {
  SET_CACHE(state, statuses) {
    state.cachedStatuses = statuses
    saveState('device.statuses', statuses)
  },
  SET_SELECTED(state, status) {
    state.selectedStatus = status
  },
}

export const actions = {
  selectStatus({ commit, state, rootState }, { status }) {
    commit('SET_SELECTED', status)
  },

  selectStatusType({ commit, state, rootState }, { statusType }) {
    if (statusType === 0) {
      return 'Idle'
    }
    if (statusType === 1) {
      return 'Running'
    }
    if (statusType === 2) {
      return 'Hold'
    }
    if (statusType === 3) {
      return 'Alarm'
    }
    if (statusType === 4) {
      return 'Unknown'
    }

    if (statusType === 'Idle') {
      return 0
    }
    if (statusType === 'Running') {
      return 1
    }
    if (statusType === 'Hold') {
      return 2
    }
    if (statusType === 'Alarm') {
      return 3
    }
    if (statusType === 'Unknown') {
      return 4
    }
  },

  fetchStatuses({ commit, state, rootState }, { clearCache }) {
    // 1. Check if we've already fetched and cachedGroups the status groups.
    const matchedStatuses = state.cachedStatuses
    if (!clearCache && matchedStatuses) {
      return Promise.resolve(matchedStatuses)
    }

    // 2. Fetch the statuses from the API and cache it in case
    // we need it again in the future.
    return axios
      .get('/api/services/app/DeviceStatus/GetAll')
      .then((response) => {
        const statuses = response.data.items
        commit('SET_CACHE', statuses)
        return statuses
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          this.$router.push('Login')
        }
        return null
      })
  },

  updateStatus({ commit, dispatch, state, rootState }, { status }) {
    return axios
      .put('/api/services/app/DeviceStatus/Update', status)
      .then((response) => {
        dispatch('fetchStatuses', { clearCache: true }).then((resp) => {
          commit('SET_SELECTED', null)
        })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },
}
